import type { NodeViewProps } from "@tiptap/vue-3";
import { isNodeSelection } from "@tiptap/vue-3";
import { computed } from "vue";

export interface UseNodeViewSelectionOverlapOptions {
  allowEmpty?: boolean;
}

export function useSelectionIntersectsNodeView(props: NodeViewProps, options: UseNodeViewSelectionOverlapOptions = {}) {
  const {
    allowEmpty = true,
  } = options;

  const intersects = computed(() => {
    const { from: selectFrom, to: selectTo, empty } = props.editor.state.selection;
    if (empty && !allowEmpty) {
      return false;
    }

    const nodeFrom = props.getPos();
    if (nodeFrom === undefined) {
      return false;
    }

    const nodeTo = nodeFrom + props.node.nodeSize - 1;
    if (nodeTo < selectFrom || nodeFrom > selectTo) {
      return false;
    }

    const nodeSelection = isNodeSelection(props.editor.state.selection);
    if (nodeSelection) {
      if (nodeTo <= selectFrom || nodeFrom >= selectTo) {
        return false;
      }
    }

    return true;
  });

  return intersects;
}

export function useSelectionWithinNodeView(props: NodeViewProps, options: UseNodeViewSelectionOverlapOptions = {}) {
  const {
    allowEmpty = true,
  } = options;

  const intersects = computed(() => {
    const { from: selectFrom, to: selectTo, empty } = props.editor.state.selection;
    if (empty && !allowEmpty) {
      return false;
    }

    const nodeFrom = props.getPos();
    if (nodeFrom === undefined) {
      return false;
    }
    const nodeTo = nodeFrom + props.node.nodeSize - 1;
    return selectFrom >= nodeFrom && selectTo <= nodeTo;
  });

  return intersects;
}

export function useIsThisNodeOnlySelection(props: NodeViewProps) {
  const isThisNodeOnlySelection = computed(() => {
    const selection = props.editor.state.selection;
    if (!isNodeSelection(selection)) {
      return false;
    }

    const { from: selectFrom, to: selectTo } = selection;
    const nodeFrom = props.getPos();
    if (nodeFrom === undefined) {
      return false;
    }
    const nodeTo = nodeFrom + props.node.nodeSize - 1;
    return selectFrom === nodeFrom && selectTo === nodeTo;
  });

  return isThisNodeOnlySelection;
}
